/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsBCSQuestionsAnswersHistoryRequest {
    getFixupPrototypeFunction() { return AppSecopsBCSQuestionsAnswersHistoryRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsBCSQuestionsAnswersHistoryRequest>): AppSecopsBCSQuestionsAnswersHistoryRequest {
        let obj = Object.assign(new AppSecopsBCSQuestionsAnswersHistoryRequest(), model);
        AppSecopsBCSQuestionsAnswersHistoryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsBCSQuestionsAnswersHistoryRequest>): AppSecopsBCSQuestionsAnswersHistoryRequest {
        if (!model) return null;
        return AppSecopsBCSQuestionsAnswersHistoryRequest.newInstance(<AppSecopsBCSQuestionsAnswersHistoryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsBCSQuestionsAnswersHistoryRequest) {
        if (!obj) return;

        models.AppSecopsBCSQuestionsAnswersHistoryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsBCSQuestionsAnswersHistoryRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsBCSQuestionsAnswersHistoryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Pagination context
     */
    list_context: models.ListContext;

}
